var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChargeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "smartphone 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.5625 0H7.4375C6.0807 0 4.97656 1.10414 4.97656 2.46094V25.5391C4.97656 26.8959 6.0807 28 7.4375 28H20.5625C21.9193 28 23.0234 26.8959 23.0234 25.5391V2.46094C23.0234 1.10414 21.9193 0 20.5625 0ZM14 24.7188C13.5472 24.7188 13.1797 24.3512 13.1797 23.8984C13.1797 23.4456 13.5472 23.0781 14 23.0781C14.4528 23.0781 14.8203 23.4456 14.8203 23.8984C14.8203 24.3512 14.4528 24.7188 14 24.7188ZM15.6406 4.92188H12.3594C11.9066 4.92188 11.5391 4.55438 11.5391 4.10156C11.5391 3.64875 11.9066 3.28125 12.3594 3.28125H15.6406C16.0934 3.28125 16.4609 3.64875 16.4609 4.10156C16.4609 4.55438 16.0934 4.92188 15.6406 4.92188Z",
    fill: "#D3AB2A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChargeIcon);
export default __webpack_public_path__ + "static/media/charge_icon.537108e137315ae30857716ab711ac68.svg";
export { ForwardRef as ReactComponent };